import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
require('jquery-ui');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');

import { ResponseService } from '../../../../../../services/response.service';

@Component({
    selector: 'match-interaction',
    template: require('./match-interaction.html'),
})
export class MatchInteractionComponent implements OnInit, AfterViewInit {

    @Input() interaction: PgRendererDto.InteractionDefinition;
    matchInteraction: PgRendererDto.MatchInteraction;
    availableChoices: PgRendererDto.SimpleAssociableChoice[];
    groups: PgRendererDto.SimpleAssociableChoice[];
    response: PgRendererDto.InteractionResponse;

    constructor(
        private responseService: ResponseService
    ) {
    }

    ngOnInit() {
        this.matchInteraction = this.interaction.MatchInteraction;
        this.response = this.responseService.getResponse(this.interaction);

        if (this.response) {
            this.availableChoices = this.matchInteraction.SimpleMatchSets[0].SimpleAssociableChoices.filter(x => this.response.Items.findIndex(r => r.Value == x.Identifier) < 0);
        } else {
            this.availableChoices = this.matchInteraction.SimpleMatchSets[0].SimpleAssociableChoices;
        }

        this.groups = this.matchInteraction.SimpleMatchSets[1].SimpleAssociableChoices;
    }

    ngAfterViewInit() {
        $(`.interaction-${this.interaction.InteractionId} .draggable`).draggable({
            revert: "invalid",
            helper: "clone",
            containment: $(".view-container")
        });
        $(`.interaction-${this.interaction.InteractionId} .choice-container`).droppable({
            over: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                if (this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.addClass("allow-drop");
                }
            },
            out: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                if (this.haveSameParentId(dropTarget, ui.draggable)) {
                    dropTarget.append(ui.draggable);
                    dropTarget.removeClass("no-drop allow-drop");
                    const id = ui.draggable.attr("id");
                    this.removeResponse(id);
                } else {
                    dropTarget.removeClass("no-drop allow-drop");
                }
            }
        });

        $(`.interaction-${this.interaction.InteractionId} .placeholder`).droppable({
            over: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                const matchMax = parseInt(dropTarget.data("matchMax"));
                const existingDraggable = dropTarget.find(".draggable");
                if (existingDraggable.length < matchMax) {
                    dropTarget.addClass("allow-drop");
                } else {
                    dropTarget.addClass("no-drop");
                }
            },
            out: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                dropTarget.removeClass("no-drop allow-drop");
            },
            drop: (event, ui: JQueryUI.DroppableEventUIParam) => {
                const dropTarget = $(event.target);
                if (this.haveSameParentId(dropTarget, ui.draggable)) {
                    const matchMax = parseInt(dropTarget.data("matchMax"));
                    if (dropTarget.find(".draggable").length < matchMax) {
                        dropTarget.append(ui.draggable);
                        const id = ui.draggable.attr("id");
                        this.removeResponse(id);
                        this.setResponse(dropTarget.attr("id"), id);
                    }
                    dropTarget.removeClass("no-drop allow-drop");
                } else {
                    dropTarget.removeClass("no-drop allow-drop");
                }
            }
        });
    }

    haveSameParentId(elem1: JQuery, elem2: JQuery): boolean {
        return elem1.data("parentId") == elem2.data("parentId");
    }

    setResponse(key: string, identifier: string) {
        this.responseService.setResponse(this.interaction, key, identifier, null, true, null);
    }

    removeResponse(identifier: string) {
        this.responseService.removeResponseItem(this.interaction.InteractionId, identifier);
    }

    getGroupChoices(groupIdentifier: string): PgRendererDto.SimpleAssociableChoice[] {
        if (this.response) {
            return this.response.Items
                .filter(r => r.Key == groupIdentifier)
                .map(r => this.matchInteraction.SimpleMatchSets[0].SimpleAssociableChoices.find(c => c.Identifier == r.Value));
        } else {
            return [];
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/match-interaction/match-interaction.component.ts